export default {
  name: "LogoMastercard",
  components: {},
  props: {
    width: {
      type: [Number, String],
      default: 48.047
    },
    height: {
      type: [Number, String],
      default: 39.41
    },
  },
  data () { return {} },
  created () {},
  computed: {},
  methods: {}
}
